import { IconInfoCircle, IconX } from "@tabler/icons-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import {
  AlertDialog,
  AlertDialogClose,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogPopup,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

interface BrandAuthorizationDialogProps {
  onAuthorize: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export function BrandAuthorizationDialog({
  onAuthorize,
  onOpenChange,
  open,
}: BrandAuthorizationDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogPopup className="max-w-[520px]">
        <AlertDialogHeader className="gap-5 pb-0">
          <div className="flex items-center justify-between gap-3">
            <AlertDialogTitle className="text-xl leading-7">请先完成品牌授权</AlertDialogTitle>
            <AlertDialogClose
              aria-label="关闭"
              className="-me-2"
              render={<Button size="icon-sm" variant="ghost" />}
            >
              <IconX />
            </AlertDialogClose>
          </div>
          <AlertDialogDescription className="leading-6">
            未检测到品牌授权信息，店铺权重、广告报表等核心数据抓取受限，无法进行竞品及市场数据比对。请先完成授权操作。
          </AlertDialogDescription>
          <Alert
            variant="warning"
            className="items-center rounded-[8px] border-badge-warning-border bg-badge-warning-background px-4 py-3 text-[13px] leading-[21px]"
          >
            <IconInfoCircle stroke={1.75} aria-hidden />
            <AlertDescription className="text-foreground">
              授权完成后，请返回并重新生成调研报告。
            </AlertDescription>
          </Alert>
        </AlertDialogHeader>
        <AlertDialogFooter variant="bare" className="gap-3 pt-6">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            取消
          </Button>
          <Button onClick={onAuthorize}>去授权</Button>
        </AlertDialogFooter>
      </AlertDialogPopup>
    </AlertDialog>
  );
}
